@if (showCondition) {
  <button mat-button
    class="kpi-definition-button"
    [matTooltip]="tooltip"
    [disabled]="disabled"
    (click)="onKpiDefinitionClick()"
    >
    <mat-icon>search</mat-icon>
    <span>{{ buttonText }}</span>
  </button>
}